<template>
  <div style="width: 600px;margin: 30px auto 0;">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="160px"
    >
      <el-form-item
        label="原密码"
        prop="oldPwd"
      >
        <el-input
          v-model="form.oldPwd"
          show-password
          placeholder="请输入原密码"
        />
      </el-form-item>
      <el-form-item
        label="新密码"
        prop="newPwd"
      >
        <el-input
          v-model="form.newPwd"
          show-password
          placeholder="请输入8位及以上数字、字母、特殊字符至少两种组合新密码"
        />
      </el-form-item>
      <el-form-item
        label="确认密码"
        prop="newPwd2"
      >
        <el-input
          v-model="form.newPwd2"
          show-password
          placeholder="请确认新密码"
        />
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        v-if="getLimit('updatePassword_submit_button')"
        type="primary"
        @click="funcSubmit"
      >
        立即提交
      </el-button>
      <el-button
        v-if="getLimit('updatePassword_reset_button')"
        @click="resetForm('form')"
      >
        重 置
      </el-button>
    </div>
  </div>
</template>
<script>
import { updatePassword } from '@/api/user'
import { checkPassword } from '@/utils/validate4Form'
const Base64 = require('js-base64').Base64

export default {
  name: 'UpdatePassword',
  components: {},
  data() {
    const validatorNewPwd2 = (rule, value, callback) => {
      if(value!=this.form.newPwd) {
        //console.log("小于8为")
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    return {
      form: {
        oldPwd: '',
        newPwd: '',
        newPwd2: ''
      },
      rules: {
        oldPwd: [
          { required: true, message: '请输入原密码', trigger: 'blur' },
          { validator: checkPassword }
        ],
        newPwd: [
          {
            required: true,
            validator: checkPassword
          }
        ],
        newPwd2: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          { validator: validatorNewPwd2 }
        ]
      }
    }
  },
  methods: {
     // 提交
    funcSubmit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if(this.form.newPwd === this.form.oldPwd){
            this.$message({ message: '请设置不同密码！', type: "warning" });
            return ;
          }
          if(this.form.newPwd === this.form.newPwd2) {
            let formData = {}
            formData.newPwd = Base64.encode(this.form.newPwd)
            formData.newPwd2 = Base64.encode(this.form.newPwd2)
            formData.oldPwd = Base64.encode(this.form.oldPwd)
            const rLoading = this.openLoading();
            updatePassword(formData)
              .then(response => {
                rLoading.close();
                this.$message({ message: response.msg, type: "success" });
              })
              .then(() => this.$refs["form"].resetFields());
          } else {
            this.$message({ message: '请确认新密码！', type: "warning" });
          }
        } else {
          return false
        }
      })
    },
    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>
<style lang="scss" scoped>
  .dialog-footer {
    margin: 15px 0 15px 0;
    width: 330px;
    float: right;
  }
</style>
